"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

var helpers_1 = require("@lws/react-components/dist/util/helpers");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/util");

var TextComponent_1 = require("../TextComponent");

var TextMediaComponent_1 = require("../TextMediaComponent");

var QuoteComponent_1 = require("../QuoteComponent");

var MediaComponent_1 = require("../MediaComponent");

var DefaultSubsectionRenderer_1 = require("./renderers/DefaultSubsectionRenderer");

var SimpleMediaLikeSubsectionRenderer_1 = require("./renderers/SimpleMediaLikeSubsectionRenderer");

var SimpleTextMediaLikeSubsectionRenderer_1 = require("./renderers/SimpleTextMediaLikeSubsectionRenderer");

var CenteredTextLikeSubsectionRenderer_1 = require("./renderers/CenteredTextLikeSubsectionRenderer");

var DefaultTextLikeSubsectionRenderer_1 = require("./renderers/DefaultTextLikeSubsectionRenderer");

var AlternatingTextMediaLikeSubsectionRenderer_1 = require("./renderers/AlternatingTextMediaLikeSubsectionRenderer");

var util_2 = require("../PageContentList/util");

var utils_1 = require("../../utils");

var NonAlternatingTextMediaLikeSubsectionRenderer_1 = require("./renderers/NonAlternatingTextMediaLikeSubsectionRenderer");

exports.sectionChildComponentMap = {
  ContentfulText: TextComponent_1.TextComponent,
  ContentfulTextMedia: TextMediaComponent_1.TextMediaComponent,
  ContentfulQuote: QuoteComponent_1.QuoteComponent,
  ContentfulMedia: MediaComponent_1.MediaComponent
}; // NOTE(benjamin):
// The following helpers might be needed in the future
// for the implementation of more complex rendering rules

function containsTextMediaElements(list) {
  return list.some(function (listItem) {
    return listItem === 'ContentfulTextMedia';
  });
}

exports.containsTextMediaElements = containsTextMediaElements;

function containsTextElements(list) {
  return list.some(function (listItem) {
    return listItem === 'ContentfulText';
  });
}

exports.containsTextElements = containsTextElements;

function containsOnlyTextElements(list) {
  return list.every(function (listItem) {
    return listItem === 'ContentfulText';
  });
}

exports.containsOnlyTextElements = containsOnlyTextElements;

function containsOnlyTextMediaElements(list) {
  return list.every(function (listItem) {
    return listItem === 'ContentfulTextMedia';
  });
}

exports.containsOnlyTextMediaElements = containsOnlyTextMediaElements;

function assembleRenderersFrom(content) {
  var groupedChildren = util_2.splitContentElementsByDescriptor(content, function (contentElement) {
    return contentElement.type();
  });
  var groupedChildrenTypes = groupedChildren.map(function (s) {
    return s[0].type();
  });
  var sectionHasTextAndTextMediaElements = containsTextElements(groupedChildrenTypes) && containsTextMediaElements(groupedChildrenTypes);
  var renderer = DefaultSubsectionRenderer_1.DefaultSubsectionRenderer;
  return groupedChildren.map(function (contentElement) {
    // TODO/NOTE(benjamin):
    // It's expected that the section component will be used across various
    // consuming projects that might each ship some specific components.
    // As this mechanism of hardcoding content types to implement visual
    // rendering rules does not scale well, we should find a way of making
    // this component as agnostic as possible in this regard and create
    // an extensibility point.
    var childType = contentElement[0].type();

    if (childType === 'ContentfulMedia') {
      renderer = SimpleMediaLikeSubsectionRenderer_1.SimpleMediaLikeSubsectionRenderer;
    }

    if (childType === 'ContentfulQuote') {
      renderer = SimpleTextMediaLikeSubsectionRenderer_1.SimpleTextMediaLikeSubsectionRenderer;
    }

    if (childType === 'ContentfulText') {
      renderer = CenteredTextLikeSubsectionRenderer_1.CenteredTextLikeSubsectionRenderer;
    }

    if (childType === 'ContentfulTextMedia') {
      renderer = AlternatingTextMediaLikeSubsectionRenderer_1.AlternatingTextMediaLikeSubsectionRenderer;
    }

    if (sectionHasTextAndTextMediaElements) {
      if (childType === 'ContentfulText') {
        renderer = DefaultTextLikeSubsectionRenderer_1.DefaultTextLikeSubsectionRenderer;
      }
    }

    return {
      renderer: renderer,
      rendererProps: {},
      component: exports.sectionChildComponentMap[childType],
      data: contentElement
    };
  });
}

exports.assembleRenderersFrom = assembleRenderersFrom;

exports.getViewportManipulator = function (viewport) {
  return function (renderer) {
    if (viewport !== 'xs' && viewport !== 'sm') {
      return renderer;
    }

    if (renderer.renderer === AlternatingTextMediaLikeSubsectionRenderer_1.AlternatingTextMediaLikeSubsectionRenderer) {
      renderer.renderer = NonAlternatingTextMediaLikeSubsectionRenderer_1.NonAlternatingTextMediaLikeSubsectionRenderer;
    }

    return renderer;
  };
};

exports.SectionComponent = function (_a) {
  var data = _a.data,
      centeredHeading = _a.centeredHeading,
      separatorBottom = _a.separatorBottom;

  var _b;

  var content = data.array('content');
  var headline = data.richText('headline');
  var overline = data.text('overline');
  var navigationName = data.slug('navigationName');
  var leadText = data.richText('leadText');
  var viewport = utils_1.useViewportSize();
  var manipulateRenderersByViewport = exports.getViewportManipulator(viewport);
  var renderedContentElements = assembleRenderersFrom(content).map(manipulateRenderersByViewport).map(function (renderer, index) {
    var Renderer = renderer.renderer;
    return react_1["default"].createElement(Renderer, {
      key: "SectionComponent-" + index,
      data: renderer.data,
      component: renderer.component,
      props: renderer.rendererProps
    });
  });
  var hasHeadline = !helpers_1.isUndefined(overline) && !helpers_1.isUndefined(headline) || !helpers_1.isUndefined(leadText); // NOTE(benjamin): To address the smooth scrolling / margin problem, we could try
  // physically adding an anchor element with the ID to scroll to before the section,
  // but this needs checking if the navigation spy still works properly when the
  // element has an actual height of 0:
  //
  // e.g. <a id="section-xxx"><a/>

  return react_1["default"].createElement(components_1.Section, {
    id: navigationName,
    separatorBottom: separatorBottom
  }, react_1["default"].createElement(components_1.Grid, null, hasHeadline && react_1["default"].createElement(GridRow_1.GridRow, {
    columnVariate: true
  }, centeredHeading && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 2
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 4,
    sm: 6,
    md: 8
  }, react_1["default"].createElement(components_1.TextSection, {
    label: overline,
    title: headline && react_1["default"].createElement("span", null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
      content: headline,
      options: util_1.footnotesFragmentsOptions
    }))
  }, leadText && react_1["default"].createElement(components_1.Paragraph, {
    size: (_b = components_1.Paragraph.Sizes) === null || _b === void 0 ? void 0 : _b.LEAD
  }, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: leadText,
    options: util_1.footnotesFragmentsOptions
  })))), centeredHeading && react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 1,
    md: 2
  }))), renderedContentElements);
};